module.exports = __webpack_public_path__ + "static/img/serpent.15ab7c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serpent.png
// module id = uEbf
// module chunks = 0